import { ToastNotification } from '@evaneos/b2b-ui/legacy';
import { resolveValue, Toaster, toast } from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';

import { AllTranslationKeys } from '../../shared/intl/types';
import { Close } from '../Icons/Close';

export function Notifications(): JSX.Element | null {
    return (
        <Toaster
            position="bottom-left"
            reverseOrder={true}
            toastOptions={{
                duration: 4000,
            }}
        >
            {(t) => {
                if (typeof t.message !== 'string') {
                    throw 'Toast message must be a string (and ideally a translation key)';
                }

                const type = t.type as 'error' | 'success';
                return (
                    <ToastNotification type={type} visible={t.visible}>
                        <p>
                            <FormattedMessage
                                id={resolveValue(t.message, t) as AllTranslationKeys}
                            />
                        </p>
                        <button
                            type="button"
                            onClick={() => toast.dismiss(t.id)}
                            style={{
                                border: 'none',
                                background: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Close color="var(--white)" />
                        </button>
                    </ToastNotification>
                );
            }}
        </Toaster>
    );
}
